import styled from '@emotion/styled'
import Select, { StylesConfig } from 'react-select'

import { InputStyledProps } from './_types'

export const InputStyled = styled.input<InputStyledProps>(({ theme, hasError }) => ({
    display: 'block',
    border: hasError
        ? `1px solid ${theme.color.semantic.error[300]}`
        : `1px solid ${theme.color.neutral.slate[100]}`,
    padding: theme.spacing(2.5, 3),
    borderRadius: theme.spacing(0.5),
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: theme.fonts.default,
    fontSize: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}))

export const InputErrorStyled = styled.div(({ theme }) => ({
    marginBottom: theme.spacing(3),
    fontSize: theme.spacing(1.5),
    color: theme.color.semantic.error[500],
    //marginLeft: theme.spacing(3),
}))

export const TextAreaStyled = styled.textarea<InputStyledProps>(({ theme, hasError }) => ({
    display: 'block',
    border: hasError
        ? `1px solid ${theme.color.semantic.error[300]}`
        : `1px solid ${theme.color.neutral.slate[100]}`,
    padding: theme.spacing(2.5, 3),
    width: '100%',
    fontFamily: theme.fonts.default,
    fontSize: theme.spacing(2),
    boxSizing: 'border-box',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
}))

export const SelectStyled = styled(Select)(({ theme }) => ({
    display: 'block',
}))

export const ContainerInnerStyled = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(4),
}))

export const ContainerInnerFormStyled = styled.div(({ theme }) => ({
    flex: '1 1 0',
    background: theme.color.neutral.salt[100],
    padding: theme.spacing(5),
    borderRadius: theme.spacing(4),
}))

export const ContainerInnerInfosStyled = styled.div(({ theme }) => ({
    flex: '1 1 0',
}))

export const SubmitStyled = styled.button(({ theme }) => ({
    border: 'none',
    padding: theme.spacing(3, 4),
    borderRadius: theme.spacing(5),
    fontSize: theme.spacing(2),
    fontFamily: theme.fonts.default,
    background: theme.color.brand.primary[500],
    color: theme.color.brand.secondary[900],
    fontWeight: 700,
    cursor: 'pointer',

    ':hover': {
        background: theme.color.brand.primary[400],
        transition: 'all ease-in-out 300ms',
    },
}))

export const ContactInfosWrapperStyled = styled.div(({ theme }) => ({
    marginLeft: theme.spacing(2),
    background: theme.color.brand.primary[100],
    padding: theme.spacing(5),
    borderRadius: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    h3: {
        fontSize: theme.spacing(4),
        marginBottom: theme.spacing(3),
        lineHeight: 1,
    },

    p: {
        fontFamily: theme.fonts.body,
        marginTop: 0,
        lineHeight: 1.5,
    },

    img: {
        width: '80%',
    },
}))
